import { render, staticRenderFns } from "./LiberdadeEB.vue?vue&type=template&id=764b4edd&scoped=true"
import script from "./LiberdadeEB.vue?vue&type=script&lang=js"
export * from "./LiberdadeEB.vue?vue&type=script&lang=js"
import style0 from "./LiberdadeEB.vue?vue&type=style&index=0&id=764b4edd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764b4edd",
  null
  
)

export default component.exports